export enum DocumentViewerActionTypes {
  REDACT_DOCUMENT = 'REDACT_DOCUMENT',
  SEARCH_BY_AI = 'SEARCH_BY_AI',
}
